import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/_services/data.service';
import { anim, slideRight } from 'src/app/animations';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-views-from-floors',
  templateUrl: './views-from-floors.component.html',
  styleUrls: ['./views-from-floors.component.scss'],
  animations: [
    slideRight, anim
  ],
  host: {
     '[@slideRight]': 'condition'
  }
})
export class ViewsFromFloorsComponent implements OnInit {
  projUid: any;
  mainSpiricalSrc: any;
  curFloorPanorama: any;
  projTile: any;
  floorNumber: any;
  title: string;
  showIframe: boolean = false;
  unika: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.unika = this.dataService.wichDesign().unika;
    this.route.params.subscribe(params => {
      this.curFloorPanorama = [];
      this.curFloorPanorama = params['viewFromFloor'];
      this.floorNumber = params['floorNumber'];
      this.projUid = params['idp'];
      this.dataService.getSpecProject(this.projUid).subscribe(proj => {
        let str = proj[0].spirical
        str = str.slice(str.indexOf('src') + 5);
        this.mainSpiricalSrc = str.slice(0 , str.indexOf('"'));
        this.projTile = proj[0].title;
        // this.pageTitle();
        this.showIframe = true;
      });
    });
  }
  // pageTitle() {
  //     if(this.projTile){
  //       if(this.floorNumber){
  //         this.title = 'Spirikal' + ' - ' + this.projTile + ' - נוף מהקומה: ' + this.floorNumber;
  //         this.titleService.setTitle(this.title);
  //       }
  //     }
  // }
}
